/* globals Waypoint */

$(() => {
  const navbar = $('.navbar');
  const waypointOffset = navbar.length ? Math.ceil(navbar.outerHeight()) + 5 : 0;

  function onViewingSection(sectionID = 'splash') {
    $('body').attr('data-viewing-section', sectionID);
    navbar.find('a.nav-link.active').removeClass('active');
    navbar.find(`a.nav-link[href='#${sectionID}']`).addClass('active');
  }

  $('.section').each((i, element) => {
    $(element).data('waypoint', new Waypoint({
      element,
      handler: (direction) => {
        if (direction === 'down') {
          onViewingSection($(element).attr('data-section-nav') || $(element).attr('data-section'));
        } else {
          onViewingSection(
            $(element).prev('.section').attr('data-section-nav') ||
            $(element).prev('.section').attr('data-section')
          );
        }
      },
      offset: waypointOffset,
    }));
  });
});
